import { React, useState, useEffect } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { AuthContext } from './context';
import { getMe } from './WebAPIs';
import { getAuthToken } from './utils';
import NavBoostrap from './components/NavBoostrap';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ReservePage from './pages/ReservePage';
import Footer from './components/Footer';

import styled from 'styled-components';
import 'react-notifications/lib/notifications.css';

const Root = styled.section`
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

function App() {
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  useEffect(() => {
    if(getAuthToken())
      getMe().then((response) => {
        if(response.ok) {
          setUser(response.authData.data);
          setUserId(response.authData.id)
        };
      })
  }, [user, userId]);

  return (
    <Root>
      <AuthContext.Provider value={{user, setUser, userId, setUserId}}>
        <Router>
          <NavBoostrap />
          <Switch>
            <Route exact path="/">
              <HomePage />
            </Route>
            <Route exact path="/menu">
              <MenuPage />
            </Route>
            <Route exact path="/login">
              <LoginPage />
            </Route>
            <Route exact path="/register">
              <RegisterPage />
            </Route>
            <Route exact path="/reserve">
              <ReservePage />
            </Route>
          </Switch>
          <Footer />
        </Router>
      </AuthContext.Provider>
    </Root>
  );
}

export default App;
